export const MARKETING_OPT_IN_COOKIE = "mf_marketing_opt_in";
export const MARKETING_OPT_IN_COOKIE_VALUE = "true";

export const isMarketingOptInCookie = (value: unknown): boolean =>
  value === MARKETING_OPT_IN_COOKIE_VALUE;

export const getMarketingConsentData = (
  marketingOptIn: boolean,
  consentedAt = new Date()
): { marketingOptIn: boolean; marketingOptInAt: Date | null } => ({
  marketingOptIn,
  marketingOptInAt: marketingOptIn ? consentedAt : null,
});
